import IconButton from "@material-ui/core/IconButton";
import BuildIcon from "@material-ui/icons/Build";
import { Menu, MenuItem } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import React from "react";
import withIntl from "../../../utils/withIntl";

function ActionButtonModifierarticle(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  return (
    <div style={{ width: "100%", display: "flex", justifyContent: "flex-end" }}>
      <IconButton
        style={{ marginRight: 40 }}
        onClick={(event) => {
          event.stopPropagation();
          setAnchorEl(event.currentTarget);
        }}
        variant="standard"
      >
        <BuildIcon colo={"primary"} />
      </IconButton>
      <Menu id="simple-menu" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            props.handleOpenEditModifierArticle();
          }}
        >
          <AddIcon color={"primary"} />
          {props.intl.formatMessage({ id: "edit_modifierarticle" })}
        </MenuItem>
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            props.removeModifierarticleFromGroup();
          }}
        >
          <AddIcon color={"primary"} />
          {props.intl.formatMessage({ id: "delete_modifierarticle" })}
        </MenuItem>
      </Menu>
    </div>
  );
}

export default withIntl(ActionButtonModifierarticle);
